import type { LandingDict } from './en';

const it: LandingDict = {
  nav: { chat: "Chat Apps", agentic: "Agentic Apps", build: "Crea app", org: "My Org", pricing: "Prezzi", privacy: "Privacy", contact: "Contatti", language: "Lingua" },
  hero: {
    titlePre: "La tua ",
    titleMark: "AI locale",
    titlePost: ".\nPotenza pura.",
    sub: "Trasforma conoscenza esperta, fogli di calcolo e riunioni in risposte, grafici e presentazioni. Nulla lascia il tuo Mac.",
    watch: "Guarda il video di 2 min",
    pill: "Ultima versione",
    chip: "Wi‑Fi spento · 0 byte inviati",
    badges: { offline: "Funziona offline", server: "Il tuo server, non il nostro", free: "Gratis per iniziare" },
    reqs: "Richiede un Mac con Apple Silicon · Almeno 16GB di memoria · Con 32GB o più sblocchi i modelli consigliati più grandi",
  },
  stats: {
    free: "Gratis",
    freeSub: "Tutte le Chat Apps, i download dei modelli e gli aggiornamenti — per sempre",
    chatApps: "Chat Apps",
    agenticApps: "Agentic Apps",
    bytesSub: "byte inviati al cloud quando l'AI gira su questo Mac",
    langsSub: "lingue dell'interfaccia, dall'italiano al 日本語",
  },
  film: { kicker: "Il film", title: "Estha in azione.", watchOnYouTube: "Guarda su YouTube", trouble: "Problemi di riproduzione? Guarda su YouTube ↗" },
  overview: {
    kicker: "Un'app, quattro modi di lavorare",
    title: "Dalla chat agli agenti,\nfino alle app per tutto il team.",
    explore: "Scopri",
    chat: { title: "Chat Apps", desc: "Esperti AI fondati su knowledge base curate — libri di testo, manuali operativi e competenze di settore.", tag: "Sempre gratis" },
    agentic: { title: "Agentic Apps", desc: "Agenti AI orientati alle attività che gestiscono lavori complessi dall'inizio alla fine.", tag: "{n}, e altre in arrivo" },
    build: { title: "Crea app", desc: "Trasforma i tuoi materiali in una Chat App con Quick Bot, o componi flussi sul canvas di Playground.", tag: "Quick Bot · Playground" },
    org: { title: "My Org", desc: "Lo spazio app della tua organizzazione, con il tuo brand, app approvate e accessi controllati.", tag: "Enterprise" },
  },
  chat: {
    kicker: "Chat Apps",
    title: "Esperti AI. Con conoscenze vere.",
    freePill: "Sempre gratis",
    lede: "Ogni Chat App ha la sua base di conoscenza, indicizzata direttamente sul tuo Mac.",
    feats: {
      kb: { title: "Basi di conoscenza locali", desc: "Quando installi un'app, la sua base di conoscenza viene creata in locale — le risposte arrivano da materiali selezionati." },
      files: { title: "Porta i tuoi file", desc: "Allega immagini, PDF, DOCX, TXT o MD — per i documenti lunghi c'è il recupero intelligente." },
      browse: { title: "Sfoglia, fissa, aggiungi ai preferiti", desc: "Categorie da Valutazione a Carriera, tag NEW per le novità, ⌘K per cercare ovunque." },
    },
  },
  agentic: {
    kicker: "Agentic Apps",
    title: "{n} Agentic Apps.\nE non è finita.",
    lede: "Da un foglio di calcolo, un PDF, una registrazione o un'idea a un grafico, una presentazione, un documento o un prototipo finiti — in privato, sul tuo Mac.",
    seeThem: "Guardale in azione",
  },
  build: {
    kicker: "Crea app",
    title: "Crea la tua Chat App.\nDirettamente sul Mac.",
    lede: "Trasforma i tuoi file in una Chat App — indicizzata in locale, pubblicata quando sei pronto.",
    quick: {
      badge: "Consigliato",
      desc: "Carica una base di conoscenza e scrivi un prompt di sistema, poi pubblica. Ottimo per trasformare rapidamente i materiali in un bot di domande e risposte.",
      items: ["Modulo di una pagina, completato in pochi passaggi", "Domande e risposte con base di conoscenza pronte all'uso", "Modelli di prompt integrati per ispirarti"],
    },
    advanced: {
      title: "Avanzato · Playground",
      desc: "Editor visuale a nodi per comporre liberamente più nodi, ramificazioni, AB test e instradamento per parole chiave.",
      items: ["Canvas dei nodi", "Multi-nodo / ramificazione / AB test", "Campi dettagliati e debug"],
    },
    guideTitle: "Una guida AI locale ti affianca mentre crei.",
    guideText: "Dille cosa vuoi che faccia l'app: ti mostra quali nodi trascinare e come collegarli. La creazione di app è inclusa in Premium.",
  },
  private: {
    kicker: "Privacy integrata",
    title: "Nessun cloud per i tuoi dati.\nNessun tracciamento del tuo lavoro.",
    lede: "Decidi tu dove gira l'IA. Per impostazione predefinita Estha sceglie il modello giusto per ogni funzione, e puoi cambiarlo quando vuoi nell'app.",
    boundary: "Confine dei dati = la tua rete",
    local: { title: "Su questo Mac", desc: "Completamente offline, niente esce da questo dispositivo. Usa la memoria di questo computer.", best: "Ideale per Mac con memoria abbondante" },
    server: { title: "Sul mio Estha Server", desc: "Sposta il lavoro pesante su un Mac più potente della tua rete e mantieni leggero questo Mac.", best: "Ideale per portatili e Mac con poca memoria" },
    cluster: { desc: "Connettiti a un cluster Mac Studio per delegare le inferenze pesanti mantenendo i tuoi dati on-premise.", best: "Rileva automaticamente i nodi Estha Studio Master sulla tua rete" },
    models: {
      every: "Funziona su tutti i Mac supportati",
      whisper: "Whisper per la trascrizione",
      recommended: "I modelli consigliati",
      larger: "Modelli Qwen e Gemma più grandi",
      vision: "Modelli di visione per le immagini",
      open: "Modelli aperti, ottimizzati per Apple Silicon",
      openItems: ["Scarica e cambia modello direttamente nell'app", "Modelli dedicati a codice ed embedding", "Download dei modelli sempre gratis"],
    },
  },
  org: {
    kicker: "My Org",
    title: "Lo spazio AI della tua organizzazione.",
    lede: "Una sezione di Estha con il tuo brand, che raccoglie le app approvate dalla tua organizzazione per le sue persone.",
    signIn: "Accedi a My Org Admin",
    talk: "Parla con il team Estha",
    feats: {
      review: { title: "Revisione prima della pubblicazione", desc: "Ogni nuova app, aggiornamento o rimozione passa da un amministratore. Ogni rifiuto arriva con un feedback scritto." },
      access: { title: "Accesso per gruppo o persona", desc: "Decidi esattamente chi vede ogni app — per reparto, team o singola persona." },
      brand: { title: "Il tuo brand, nell'app", desc: "Nome dell'organizzazione, messaggio di benvenuto, logo, banner e colore del tema — con anteprima prima della pubblicazione." },
    },
  },
  pricing: {
    kicker: "Abbonamento",
    title: "Inizia gratis. Sblocca tutto quando vuoi.",
    free: { name: "Gratis", sub: "Gratis, per sempre.", items: ["Tutte le Chat Apps", "Elaborazione documenti, gratis per sempre", "Download dei modelli, software e aggiornamenti — sempre gratuiti"] },
    premium: {
      name: "Premium", flag: "Prova gratuita di 14 giorni", firstYear: "il primo anno",
      sub: "Poi $30/anno. Inizia con una prova gratuita di 14 giorni dopo aver verificato la tua email.",
      items: ["Tutto ciò che è incluso in Gratis", "Tutte le Agentic Apps attuali e future", "Creatore di Chat App — crea, modifica, visualizza in anteprima, salva e pubblica chatbot locali"],
      cta: "Inizia la prova nell'app",
    },
    enterprise: {
      name: "Enterprise", price: "Parliamone", sub: "Per le organizzazioni che portano Estha nei propri team.",
      items: ["Tutto ciò che è incluso in Premium", "Chat Apps e Agentic Apps personalizzate per il tuo team", "Funzionalità dell'app Estha Server", "Spazio app My Org e My Org Admin"],
    },
  },
  faq: {
    title: "Da sapere\nprima di scaricare.",
    spec: { chip: "Chip", memory: "Memoria", memMin: "Almeno 16GB", memRec: "32GB o più per i modelli consigliati", languages: "Lingue", langsVal: "13 lingue dell'interfaccia", version: "Ultima versione" },
    qa: [
      { q: "Qualcosa lascia il mio Mac?", a: "Quando l'AI gira su questo Mac, è tutto offline — niente esce dal computer. Se scegli un Estha Server o un Mac Studio Cluster, il lavoro viene inviato solo a quella macchina, sulla tua rete." },
      { q: "Cosa richiede una connessione a Internet?", a: "Poche cose: accesso e verifica dell'e-mail per la prova Premium, download dei modelli e controllo degli aggiornamenti. Prompt, file e risultati non vengono mai caricati: una volta scaricato il modello, l'IA funziona completamente offline." },
      { q: "Cosa è gratis e cosa è Premium?", a: "Tutte le Chat Apps, Elaborazione documenti, i download dei modelli e gli aggiornamenti sono gratis. Premium sblocca tutte le Agentic Apps attuali e future e il creatore di Chat App, con una prova gratuita di 14 giorni." },
      { q: "Quali modelli AI usa?", a: "I migliori modelli open source come Qwen e Gemma, più Whisper per la trascrizione, eseguiti con il motore MLX di Apple. Li scarichi e li cambi direttamente nell'app." },
      { q: "Posso creare la mia app?", a: "Sì. Con Quick Bot trasformi fino a tre file in una Chat App con base di conoscenza in pochi passaggi; con il canvas a nodi di Playground crei ramificazioni, AB test e quiz. Una guida locale ti accompagna lungo il percorso." },
      { q: "Come lo adottano le organizzazioni?", a: "Con Enterprise, gli amministratori gestiscono utenti e gruppi in My Org Admin e approvano ogni app prima della pubblicazione; i membri trovano in Estha uno spazio My Org con il brand dell'organizzazione. Scrivi a {email}." },
    ],
  },
  final: { title: "Pronto a portare l'AI in locale?", reqs: "Funziona su qualsiasi Mac con Apple Silicon · Almeno 16GB di RAM" },
  footer: {
    tagline: "La tua AI locale, potenza pura — sul dispositivo, basata su MLX, privata per progettazione.",
    product: "Prodotto", createApp: "Crea app", pricing: "Prezzi",
    orgs: "My Org", signIn: "Accedi a My Org Admin",
    security: "Sicurezza", changelog: "Novità", docs: "Documentazione", support: "Assistenza",
    company: "Azienda", privacy: "Informativa sulla privacy", terms: "Termini di servizio",
    rights: "© 2026 Estha. Tutti i diritti riservati.",
  },
  proof: { press: "Parlano di noi", voices: "Cosa dicono i team" },
  contact: {
    title: "Scrivi al team Estha", copy: "Copia indirizzo email", copied: "Copiato",
    gmail: "Scrivi con Gmail", mailApp: "Apri nell'app Mail",
    subject: "Richiesta su Estha for Mac",
  },
  share: {
    button: "Condividi", title: "Condividi Estha",
    sub: "Scegli una card e pubblicala, oppure invia solo il link.",
    style: "Card", size: "Formato",
    templates: { hero: "Estha", agentic: "Agentic Apps", private: "Privacy" },
    landscape: "Orizzontale", portrait: "Verticale",
    shareImage: "Condividi immagine…", download: "Scarica immagine", copyImage: "Copia immagine", copied: "Copiato",
    copyLink: "Copia link", link: "Link", postTo: "Pubblica su",
    email: "Email",
    text: "Estha esegue modelli di AI open source interamente sul tuo Mac: privato, offline e gratuito.",
    cardCta: "Download gratuito per Mac con Apple Silicon",
    close: "Chiudi",
  },
  apps: {
    dataAnalyst: { name: "Analista dati", description: "Carica file CSV/Excel e fai domande in linguaggio naturale. Genera automaticamente grafici, analisi statistiche e approfondimenti sui dati — tutto elaborato localmente sul tuo Mac.", tags: ["CSV / Excel", "Grafici automatici", "Query in linguaggio naturale", "EN / 中文"] },
    pptMaker: { name: "PPT Maker", description: "Descrivi l'argomento della tua presentazione e ottieni una presentazione PowerPoint con una struttura professionale. Una pipeline AI multi-step genera la scaletta, il contenuto di ogni diapositiva e un file .pptx rifinito.", tags: ["Output .pptx", "Layout automatico", "Pipeline multi-step"] },
    pdfReader: { name: "Lettore PDF", description: "Apri un PDF e dialoga con esso. Ogni risposta si basa sul documento, con citazioni cliccabili che portano al passaggio di origine esatto — tutto elaborato localmente sul tuo Mac.", tags: ["Domande sul PDF", "Citazioni verificabili", "Domanda su selezione", "100% locale"] },
    documentProcessing: { name: "Elaborazione documenti", description: "Il tuo esperto di documenti tutto-in-uno. Scrivi da zero articoli per blog, testi per i social, clausole legali e documenti aziendali. Modifica e ottimizza file esistenti, traduci tra le lingue e rivedi i contenuti per garantirne la qualità — tutto in privato sul tuo Mac.", tags: ["Stesura e scrittura", "Modifica e ottimizzazione", "Traduzione", "Revisione e controllo"] },
    meetingIntelligence: { name: "Meeting Intelligence", description: "Registra, trascrivi e analizza le riunioni con l'AI. Genera automaticamente verbali, attività da svolgere e decisioni chiave — con totale privacy, nessun audio lascia mai il tuo dispositivo.", tags: ["Trascrizione", "Verbali di riunione", "Attività da svolgere", "100% privato"] },
    vibeCoding: { name: "Vibe Coding: Prototipo", description: "Crea anteprime interattive con l'IA. Descrivi un'interfaccia in linguaggio naturale, ottieni un prototipo cliccabile e continua a iterarci. Produce un unico file .html autonomo, generato interamente sul tuo Mac.", tags: ["File .html singolo", "Anteprima interattiva", "Modifica al clic", "100% locale"] },
    translate: { name: "Traduci", description: "Traduci testo e documenti Word, di testo o Markdown con un glossario condiviso che mantiene coerenti i tuoi termini, tutto elaborato in locale sul tuo Mac.", tags: ["Testo e documenti", ".docx / .txt / .md", "Glossario", "100% locale"] },
  },
  screens: {
    chat: [
      { label: "Sfoglia lo store", caption: "Sfoglia, installa, fissa — sempre gratis" },
      { label: "Installa", caption: "Le basi di conoscenza vengono create in locale all'installazione" },
      { label: "Chiedi", caption: "Risposte fondate sul suo playbook" },
    ],
    build: [
      { label: "Crea app", caption: "Quick Bot o Avanzato — entrambi pronti per chattare" },
      { label: "Quick Bot", caption: "Carica una base di conoscenza. Scrivi un prompt. Pubblica." },
      { label: "Playground", caption: "Nodi, ramificazioni e conoscenza — in modo visuale" },
      { label: "Pubblicata", caption: "Pubblicata e pronta per chattare" },
    ],
    analyst: [
      { label: "Fai una domanda", caption: "Interroga i tuoi dati in linguaggio naturale" },
      { label: "Analisi", caption: "Analizzati sul tuo Mac" },
      { label: "Grafico e insight", caption: "La risposta, il grafico e come ci si è arrivati" },
    ],
    ppt: [
      { label: "Imposta", caption: "Argomento, slide, lingua, tono, tema" },
      { label: "Rivedi la scaletta", caption: "Modifica la scaletta prima di generare" },
      { label: "Anteprima", caption: "Un .pptx finito e modificabile — sul tuo Mac" },
    ],
    pdf: [
      { label: "Apri un PDF", caption: "Articoli, report, manuali e documenti scansionati" },
      { label: "Lettura", caption: "Letto in locale, pagina per pagina" },
      { label: "Risposta con fonti", caption: "Ogni risposta rimanda alla clausola esatta" },
    ],
    doc: [
      { label: "Seleziona un passaggio", caption: "Seleziona il testo e di’ cosa vuoi" },
      { label: "Riscrittura", caption: "Riscritto direttamente nel documento" },
      { label: "Accetta o rifiuta", caption: "Riscrivi, rifinisci, traduci — accetta o rifiuta" },
    ],
    meeting: [
      { label: "Registra", caption: "Trascrizione dal vivo, su questo Mac" },
      { label: "Scegli i risultati", caption: "Scegli cosa generare" },
      { label: "Riepilogo", caption: "Decisioni e attività, scritte per te" },
      { label: "Attività", caption: "Responsabili e scadenze, con le prove" },
    ],
    vibe: [
      { label: "Descrivi", caption: "Descrivi un'interfaccia in linguaggio naturale" },
      { label: "Generazione", caption: "Creato interamente su questo Mac" },
      { label: "Prototipo", caption: "Cliccabile, con versioni, un unico file .html" },
      { label: "Modifica al clic", caption: "Seleziona una parte e di’ cosa cambiare" },
    ],
    translate: [
      { label: "Traduci testo", caption: "Le parole in viola vengono dal tuo glossario" },
      { label: "Traduci un documento", caption: ".docx, .txt o .md — l’originale resta invariato" },
      { label: "Glossario", caption: "Il glossario mantiene coerente ogni termine" },
    ],
    private: [
      { label: "Su questo Mac", caption: "Completamente offline. Niente esce da questo computer." },
      { label: "Mac Studio Cluster", caption: "Modelli più pesanti — on-premise" },
    ],
    org: [
      { label: "Spazio app", caption: "Spazio con il tuo brand, app create per il team" },
      { label: "Piano Enterprise", caption: "I membri aprono solo le app che autorizzi" },
    ],
  },
};

export default it;
